"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.archiveItem = archiveItem;
const path = __importStar(require("path"));
const dist_1 = require("../../fs/dist");
async function archiveItem(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const loomDir = path.join(loomRoot, 'loom');
    const prefix = loomDir + path.sep;
    let source;
    if ('docUlid' in input && input.docUlid) {
        const { filePath } = await deps.resolveDocIdOrThrow(loomRoot, input.docUlid);
        const refsPrefix = path.join(loomDir, 'refs') + path.sep;
        if (!filePath.startsWith(refsPrefix)) {
            throw new Error('Only references (loom/refs) archive individually — everything else archives with its whole thread: pass { weaveSlug, threadSlug? }.');
        }
        source = filePath;
    }
    else if ('weaveSlug' in input && input.weaveSlug) {
        source = input.threadSlug
            ? path.join(loomDir, input.weaveSlug, input.threadSlug)
            : path.join(loomDir, input.weaveSlug);
    }
    else {
        throw new Error('archiveItem requires { weaveSlug, threadSlug? } or a reference { docUlid }.');
    }
    if (!source.startsWith(prefix)) {
        throw new Error(`Cannot archive: ${source} is not inside loom/.`);
    }
    if (!(await deps.fs.pathExists(source))) {
        // If the .archive mirror exists, the item is already archived — say so clearly.
        const rel = source.slice(prefix.length);
        if (await deps.fs.pathExists(path.join(loomDir, '.archive', rel))) {
            throw new Error(`'${rel}' is already archived.`);
        }
        throw new Error(`Nothing to archive at ${path.relative(loomRoot, source)}.`);
    }
    // Mirror the path under the single top-level loom/.archive/ tree.
    const rel = source.slice(prefix.length);
    const archivedPath = path.join(loomDir, '.archive', rel);
    await (0, dist_1.moveTreeOrThrow)(source, archivedPath, deps.fs);
    return { source, archivedPath };
}
